<template>
  <div class="p-5 feature-page" style="background: linear-gradient(rgb(255, 247, 247), rgb(246, 246, 249));">

    <div class="d-flex justify-content-between">
      <div>
        <h3 class="mb-1">Most wanted features</h3>

        <!-- <div style="color:#999" class="mb-2">Every user has 3 upvotes per day.</div> -->
        <div style="color: #999" class="mb-2">
          Every user has 10 upvotes. You'll get more upvotes, when inviting new users.
          <!-- <pre>{{userReadonly.goalcoins}}</pre> -->
          <!-- You invited <strong>{{userReadonly.referralBonus}}</strong> users. -->
          You have <strong>{{userReadonly.referralBonus || 0}}</strong> upvotes left.
        </div>
      </div>

      <div class="feature-page__vote px-4 py-2" style="background: var(--red)">
        <div style="font-size: 30pt; line-height: 1;">{{userReadonly.referralBonus || 0}}</div>
        <div style="font-size: 10pt">Votes left</div>
      </div>
    </div>

    <div v-if="features_sorted.$readySome" class="">
      <transition-group name="flip-list" tag="div">
        <div
          class="card feature-page__item mt-4 mb-4 p-3"
          v-for="feature in features_sorted_not_deleted"
          :key="feature.$key">
          <div class="mr-3">
            <div class="feature-page__vote mb-2 py-2">
              <div style="font-size: 30pt; line-height: 1;">{{feature.upvotes || 0}}</div>
              <div style="font-size: 12pt">Votes</div>
            </div>
            <el-button
              @click="onUpvote( feature.$id )"
              plain
              :disabled="userReadonly.referralBonus <= 0"
              class="mb-2">
              + 1 vote
            </el-button>
            <el-tag v-if="feature.isPlanned" type="success" size="small" style="display: block; text-align: center">
              Planned
            </el-tag>
          </div>

          <div class="w-100">
            <h3 class="m-0 pb-0 mb-0">
              <inline-editable-text
                @change="onSetFeatureName( feature.$id, $event )"
                :is-editable="feature_info[ feature.$id ].allowedToEdit"
                :value="feature.title"
                :inline="true"
                :reset-on-update="false"
                :reset-on-cancel="false"
                :lost-focus-is-update="false"
                />
            </h3>
            <div class="feature-page__item__info">
              Created at
                {{feature.createdAt|shortDate}}
              by
              <user-mini-avatar :user-id="feature.createdBy" :show-name="true" size="small" />
              <!--
              <router-link :to="{ name: 'user', params: { userId: feature.createdBy }}">
                {{ contactById( feature.createdBy ).displayName }}
                <img :src="contactById( feature.createdBy ).profilePic }}" />
              </router-link>
              -->
            </div>

            <markdown-text
              @input="onSetDescription( feature.$id, $event )"
              @mode-changed="edit_mode_active = $event"
              :is-editable="feature_info[ feature.$id ].allowedToEdit"
              :value="feature.description"
              :show-as-markdown="true"
              :enable-inline-editing="true"  />

            <!-- <pre>feature: {{feature}}</pre> -->
            <!-- <pre>feature_info: {{feature_info[ feature.$id ]}}</pre> -->

          </div>
        </div>
      </transition-group>
    </div>

    <el-button @click="onCreateFeature" class="btn-block" plain type="primary" style="border-width: 2px">
      Create new feature request
    </el-button>

    <portal to="modal-target-goal-details">
      <el-dialog title="Add new feature request" :visible.sync="form_visible">
        <el-form
          @submit.native.prevent="onSubmitForm"
          :rules="rules"
          :model="form"
          ref="featureForm"
          label-position="top"
          status-icon>
          <el-form-item label="New feature" prop="title">
            <el-input v-model="form.title" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="Description" prop="description">
            <!-- <el-input type="textarea" v-model="form.description" autocomplete="off"></el-input> -->
            <text-editor v-model="form.description" :disable-save-cancel="true" />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmitForm">Submit</el-button>
            <el-button @click="onResetForm">Reset</el-button>
          </el-form-item>
        </el-form>
        <!-- <pre>form: {{form}}</pre> -->
      </el-dialog>
    </portal>

  </div>
</template>

<script>
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"

// TODO: Allow users to comment on feature proposals

export default {
  name: "FeaturesPage",
  mixins: [ ConfirmDeletePromptMixin ],
  data: () => ({
    // Inline:
    feature_title: '',
    feature_description: '',
    edit_mode_active: false,
    // Modal:
    form_visible: false,
    form: {}
  }),
  watch: {
    features_sorted_not_deleted( list ) {
      Object.keys(list).forEach(idx => {
        // let feature = list[ idx ]
        // this.$api.contact_add_if_not_cached( feature.createdBy );
        // See user-mini-avatar.vue
      });
    },
  },
  computed: {
    userReadonly() {
      return this.$models.userReadonly.subscribeNode( this.$models.user.defaultUserId )
    },

    features_sorted() {
      return this.$models.feature.subscribeList()
    },

    features_sorted_not_deleted() {
      return this.features_sorted.itemsAsArrayWithoutDeleted('-upvotes')
    },

    feature_info() {
      let info = {}
      this.features_sorted_not_deleted.forEach(feature => {
        info[feature.$id] = {
          allowedToEdit: feature.createdBy === this.$models.user.defaultUserId
        }
      })
      return info;
    },

    rules() {
      return this.$models.feature.rules;
    }
  },
  methods: {

    contactById( userId ) {
      return this.$models.userContact.get_contact_by_id( userId )
    },

    onCreateFeature(variant) {
      this.form = this.$models.feature.new_from_template({
        user_id: this.$models.user.defaultUserId
      })
      this.form_visible = true;
      this.form.setValidationBehaviour('ELEMENT_VALIDATION')
    },

    onDeleteFeature( featureId, soft_delete = true ) {
      if ( soft_delete ) {
        return this.$models.feature.remove( featureId, true );
      }
      this.$confirm_delete_prompt('feature').then(({ notify }) => {
        this.$models.feature.remove( featureId, soft_delete ).then(notify)
      }).catch(e => e)
    },

    onSubmitForm() {
      console.log("onSubmitForm");
      this.$refs.featureForm.validate((valid) => {
        if (valid) {
          this.form.write().then(() => {
            this.form_visible = false;
          });
        } else {
          return false;
        }
      });
    },

    onResetForm() {
      this.$refs.featureForm.resetFields();
    },

    onSetFeatureName( feature_id, title ) {
      console.log("onSetFeatureName", feature_id, title);
      this.$models.feature.update( feature_id, { title: title })
    },

    onSetDescription(feature_id, description) {
      console.log("onSetDescription", feature_id, description )
      this.$models.feature.update( feature_id, { description: description })
    },

    onUpvote( feature_id ) {
      // TODO !!!
      this.$models.feature.transaction( feature_id, 'upvotes', 'inc')
      this.$models.userReadonly.transaction( this.$models.user.defaultUserId, 'referralBonus', 'dec')
    },
  },
};
</script>

<style>
.feature-page__item {
  flex-direction: row;
  display: flex;
  background-color: white;
}
.feature-page__vote {
  text-align: center;
  font-weight: bold;
  color: white;
  background: #409eff;
  border-radius: 3px;
}
.feature-page__item .markdown-text__text {
  background-color: white;
  /* border: 1px solid #eee; */
  border: none;
  /* min-height: 90px; */
  padding-left: 0;
  margin-top: 0.75em;
  /* padding-right: 30px; */
}
.feature-page__item__info {
  color: grey;
}
.feature-page__item .inline-editable-text {
  min-height: 1em;
}
.feature-page__item .inline-editable-text__text,
.feature-page__item .inline-editable-text__text:hover {
  line-height: 1em;
  min-height: 1em;
}
.feature-page__item .inline-editable-text__buttons.buttons-below {
  bottom: -33px;
}

.feature-page .flip-list-enter,
.feature-page .flip-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.feature-page .flip-list-move {
  transition: transform 0.7s;
}
</style>
